"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageStatisticsResultsComponent = UsageStatisticsResultsComponent;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const pagination_1 = require("@genesys/client-core/lib/pagination");
function UsageStatisticsResultsComponent(props) {
    return (React.createElement("div", null,
        React.createElement(Elements.InnerContainer, null,
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement("div", null,
                    React.createElement(Elements.StandardButton, { onClick: () => props.copyCallback() }, "Copy")),
                React.createElement(Exporter.XlsxSingleSheetExport, { data: props.generateFileFormat(), filename: "statistics" }, onClick => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download"))))),
        React.createElement(pagination_1.PaginationComponent, { currentPage: props.currentPage, itemsPerPage: props.itemsPerPage, numberOfPages: Math.ceil(props.results.length / props.itemsPerPage), onPageChange: pageNumber => {
                props.changePageCallback(pageNumber);
            }, onRefresh: () => {
                props.refreshCallback();
            }, totalItems: props.results.length }),
        React.createElement(Elements.DataPresenterTable, null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Sales organisation"),
                    React.createElement("th", null, "System type"),
                    React.createElement("th", null, "Status"),
                    React.createElement("th", null, "Date"),
                    React.createElement("th", null, "User"),
                    React.createElement("th", null, "Deleted"),
                    React.createElement("th", null, "Count"),
                    React.createElement("th", null, "Last used"),
                    React.createElement("th", null, "GenesysNo"))),
            React.createElement("tbody", null, props.results
                .slice((props.currentPage - 1) * props.itemsPerPage, props.currentPage * props.itemsPerPage)
                .map(r => resultTableRow(r))))));
}
function resultTableRow(row) {
    return (React.createElement("tr", { key: row.id },
        React.createElement("td", null, row.salesOrganisation),
        React.createElement("td", null, row.systemType),
        React.createElement("td", null, row.status),
        React.createElement("td", null, row.date),
        React.createElement("td", null, row.user),
        React.createElement("td", null, row.deleted),
        React.createElement("td", null, row.count),
        React.createElement("td", null, row.lastUsed),
        React.createElement("td", null, row.genesysNo)));
}
//# sourceMappingURL=usage-statistics-results-component.js.map